<template>
  <div class="exam">
    <div class="exam-header">
      <div class="exam-header-left">
        <draggable tag="span" :list="questions" handle=".handle" class="type-btn">
          <el-button class="handle" type="primary" plain v-for="(item,index) in questions" :key="item.name" :name="index+1" :class="{'active':item.type == activeType }"
            @click="checkType(item.type,item.name)">{{item.name}}({{item.num}})
          </el-button>
          <el-dropdown trigger="click">
            <el-button type="primary" class="el-dropdown-link" v-show="showAddible">+ 添加题型</el-button>
            <el-dropdown-menu slot="dropdown" class="add-question-type">
              <div class="question-type-head">
                <span>选择题型</span>
              </div>
              <div class="question-type-content">
                <template v-for="(item,idx) in typeList">
                  <el-dropdown-item class="type-item" v-if="item.status" :key="idx">
                    <div class="type-title" @click="create(item.type,item.name)">
                      <img :src="item.img" />
                      <span class="text">{{item.name}}</span>
                    </div>
                  </el-dropdown-item>
                </template>
                <el-dropdown-item class="type-item">
                  <div class="type-title">
                    <img src="../../assets/imgs/article04.png" />
                    <span class="text">导入题库</span>
                  </div>
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </draggable>
      </div>
      <div class="exam-header-right">
        <el-button type="primary" style="width: 255px;" plain @click="examSet"><i class="el-icon-s-tools"></i> 试卷设置</el-button>
      </div>
    </div>
    <div class="exam-content">
      <div class="exam-content-left">
        <div class="question-list-content" v-if="questionListVisible">
          <el-collapse v-model="activeName" accordion>
            <draggable tag="div" :list="checkList" class="list-group" handle=".handle" :options="{dragClass:'dragclass'}" @update="datadragEnd">
              <el-collapse-item class="list-group-item exam-slot" v-for="(element, idx) in checkList" :key="element.index" :name="idx+1" :id="idx">
                <template slot="title" v-if="element.paper_type==9">
                  <div class="slot-title">
                    <span class="subject-sort">({{idx+1}})</span>
                    <span class="subject-title" v-html="element.topic_title"></span>
                    <span class="subject-operation" @click.stop>
                      <i class="el-icon-close" @click="delQuestion(element.id,activeType,idx)" title="删除"></i>
                      <i class="el-icon-edit-outline" @click="editQuestion(element.id,activeType,idx)" title="编辑"></i>
                      <i class="handle el-icon-rank" title="移动"></i>
                    </span>
                  </div>
                </template>
                <template slot="title" v-else-if="element.paper_type">
                  <div class="slot-title">
                    <span class="subject-sort">({{idx+1}})</span>
                    <span class="subject-title" v-html="element.topic_title.content"></span>
                    <span class="subject-operation" @click.stop>
                      <i class="el-icon-close" @click="delQuestion(element.id,activeType,idx)" title="删除"></i>
                      <i class="el-icon-edit-outline" @click="editQuestion(element.id,activeType,idx)" title="编辑"></i>
                      <i class="handle el-icon-rank" title="移动"></i>
                    </span>
                  </div>
                </template>
                <Answer customclass="answer-content" v-if="activeName" :activeType="element.paper_type" :answerData="element" :isParsing="showAnswer"></Answer>
              </el-collapse-item>
            </draggable>
          </el-collapse>
          <div>
            <el-button type="primary" @click="addQuestion">+{{subtitle}}</el-button>
          </div>
        </div>
      </div>
      <div class="exam-content-right">
        <div class="exam-setting-header">
          <span title="">题量：{{totalCount}}</span>
          <span title="">总分：{{totalScore}}</span>
        </div>
        <div class="exam-setting-preview">
          <span>
            <i class="el-icon-view" style="position: relative;top: 2px;left: -5px;"></i>预览
          </span>
        </div>
        <div class="show-question-list">
          <div class="exam-question-num" v-for="(item,i) in questions" :key="i">
            <span class="type-item">{{item.name}}</span>共{{item.score}}分
            <ul class="question-list">
              <li v-for="(it,idx) in item.qArr" :class="{'active':item.type+'-'+idx == activeType+'-'+(activeName-1) }" :key="idx" @click="checkQuestion(item.type,idx)">
                <a :href="`#`+idx">{{idx+1}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="tableVisible" custom-class="qtype" top="0" :close-on-click-modal="false" :before-close="beforeClose">
      <Sc v-if="activeType == 1 && tableVisible" ref="mychild" :paperId="paperId" :contentId="contentId" :editorData="editorData"></Sc>
      <Mc v-else-if="activeType == 2 && tableVisible" ref="mychild" :paperId="paperId" :contentId="contentId" :editorData="editorData"></Mc>
      <Judge v-else-if="activeType == 3 && tableVisible" ref="mychild" :paperId="paperId" :contentId="contentId" :editorData="editorData"></Judge>
      <Fill v-else-if="activeType == 4 && tableVisible" ref="mychild" :paperId="paperId" :contentId="contentId" :editorData="editorData"></Fill>
      <!-- <GapFill v-else-if="activeType == 5 && tableVisible" ref="mychild" :paperId="paperId" :contentId="contentId" :editorData="editorData"></GapFill> -->
      <!-- <Connect v-else-if="activeType == 6 && tableVisible" ref="mychild" :paperId="paperId" :contentId="contentId" :editorData="editorData"></Connect> -->
      <Explain v-else-if="activeType == 7 && tableVisible" ref="mychild" :paperId="paperId" :contentId="contentId" :editorData="editorData"></Explain>
      <SAnswer v-else-if="activeType == 8 && tableVisible" ref="mychild" :paperId="paperId" :contentId="contentId" :editorData="editorData"></SAnswer>
      <Train v-else-if="activeType == 9 && tableVisible" ref="mychild" :paperId="paperId" :contentId="contentId" :editorData="editorData"></Train>
      <MSort v-else-if="activeType == 10 && tableVisible" ref="mychild" :paperId="paperId" :contentId="contentId" :editorData="editorData"></MSort>
    </el-dialog>
  </div>

</template>

<script>
import {
  selectSinglePaperData, selectPaperTypeTopic, deletePaperTopicContentData,
  saveSinglePaperData
} from "@/api/contest";
import Answer from "@/components/test/Answer";//答案解析
import Sc from "@/components/test/SingleChoice";//单选
import Mc from "@/components/test/MultipleChoice";//多选
import Judge from "@/components/test/Judgement";//判断
import MSort from "@/components/test/MultipleSort";//排序
import Fill from "@/components/test/Fill";//填空
// import GapFill from "@/components/test/GapFill";//选词填空
// import Connect from "@/components/test/Line";//连线
import Explain from "@/components/test/Explain";//名词解释
import SAnswer from "@/components/test/ShortAnswer";//解答
import Train from "@/components/test/Training";//实训
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
    Answer,
    Sc,
    Mc,
    Judge,
    Fill,
    // GapFill,
    // Connect,
    Explain,
    Train,
    SAnswer,
    MSort
  },
  created() {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  },
  beforeDestroy() {
    this.$root.$off('returntopic')
    this.$root.$off('returntrain')
    sessionStorage.removeItem('checkList')
  },
  watch: {
    questions: function () {
      this.watchType()
    },
    showAnswer: function () {
      if (this.$refs.myanswer) {
        this.$refs.myanswer.showAnswer = this.showAnswer
      }
    }
  },
  mounted() {
    this.initData();
    this.watchType();
    this.$root.$on('returntopic', (subjectObj) => {
      if (Object.keys(subjectObj).length > 0) {
        this.activeName = 0
        let ind = 0
        //判断是否存在该题型
        var sort = this.questions.findIndex((val) => {
          return val.type === subjectObj.topic_title.type
        })
        let ty = subjectObj.topic_title.type
        if (sort === -1) {
          let newQ = {
            type: ty,
            name: this.findName(ty),
            num: 1,
            score: subjectObj.info[ty].single_score,
            qArr: [subjectObj.id]
          }
          this.questions.push(newQ)
          this.questionListVisible = true
          this.subtitle = this.findName(ty)
          let params = {
            paper_id: this.paper_id,
            paper_type: ty
          }
          selectPaperTypeTopic(params).then(response => {
            this.checkList = response.data
            sessionStorage.setItem('checkList', JSON.stringify(this.checkList))
          })
          ind = 1
        } else {
          var index = this.checkList.findIndex((val) => {
            return val.id === subjectObj.id
          })
          let obj = {
            id: subjectObj.id,
            paper_type: ty,
            parsing: subjectObj.parsing,
            answer: subjectObj.answer,
            topic_title: subjectObj.topic_title,
            activity_attribute: subjectObj.activity_attribute,
            difficulty: subjectObj.difficulty,
            experience: subjectObj.experience,
            integral: subjectObj.integral,
            label: subjectObj.label,
            score: subjectObj.score,
            disorder: subjectObj.disorder
          }
          if (index === -1) {
            this.checkList.push(obj)
            this.questions[sort].num++
            this.questions[sort].qArr.push(subjectObj.id)
            ind = this.checkList.length
          } else {
            this.checkList.splice(index, 1, obj)
            ind = index + 1
          }
          this.questions[sort].score = subjectObj.info[ty].single_score
          sessionStorage.setItem('checkList', JSON.stringify(this.checkList))
        }
        this.setInterName = setTimeout(() => {
          this.activeName = ind
        }, 1000)
        this.totalScore = subjectObj.total_score
        this.totalCount = subjectObj.count

      }
      this.lastType = ''
      this.$root.$emit('resetexamId', -1)
      this.tableVisible = false

    }),
      //实训题返回
      this.$root.$on('returntrain', (subjectObj) => {
        if (Object.keys(subjectObj).length > 0) {
          this.activeName = 0
          let ind = 0
          //判断是否存在该题型
          var sort = this.questions.findIndex((val) => {
            return val.type === 9
          })
          let ty = 9
          if (sort === -1) {
            let newQ = {
              type: 9,
              name: '实训题',
              num: 1,
              score: subjectObj.info[9].single_score,
              qArr: [subjectObj.id]
            }
            this.questions.push(newQ)
            this.questionListVisible = true
            this.subtitle = '实训题'
            let params = {
              paper_id: this.paper_id,
              paper_type: 9
            }
            selectPaperTypeTopic(params).then(response => {
              this.checkList = response.data
              sessionStorage.setItem('checkList', JSON.stringify(this.checkList))
            })
            ind = 1
          } else {
            var index = this.checkList.findIndex((val) => {
              return val.id === subjectObj.id
            })
            if (index === -1) {
              this.checkList.push(subjectObj.content)
              this.questions[sort].num++
              this.questions[sort].qArr.push(subjectObj.id)
              ind = this.checkList.length
            } else {
              this.checkList.splice(index, 1, subjectObj.content)
              ind = index + 1
            }
            this.questions[sort].score = subjectObj.info[9].single_score
            sessionStorage.setItem('checkList', JSON.stringify(this.checkList))
          }
          this.setInterName = setTimeout(() => {
            this.activeName = ind
          }, 1000)
          this.totalScore = subjectObj.total_score
          this.totalCount = subjectObj.count
        }
        this.lastType = ''
        this.$root.$emit('resetexamId', -1)
        this.tableVisible = false
      })
  },
  props: ['paperId'],
  data() {
    return {
      paper_id: this.paperId,
      contentId: '',//编辑试题时需要传的试题id
      showAnswer: true,//是否显示答案及解析
      activeType: 0,//主体部分头部题型切换
      lastType: '',//上一次选中的题型，添加新题目关闭后要用到
      activeName: 1,//题目列表激活的面板
      tableVisible: false,//添加题目弹窗
      questionListVisible: false,//题目列表显示
      addibleType: [],//可添加题型
      showAddible: true,//显示添加题型按钮
      subtitle: '',//选中题型名称
      totalScore: '',//总分
      totalCount: '',//总题量
      singleScore: '',//单类型分数
      editorData: '',//编辑题目时传入该题的数据
      dragging: false,
      checkList: [],//选中题型题目列表
      questions: [],
      typeList: [
        { type: 1, name: '单选题', img: require('@/assets/imgs/radio01.png'), status: 1 },
        { type: 2, name: '多选题', img: require('@/assets/imgs/multiple01.png'), status: 1 },
        { type: 3, name: '判断题', img: require('@/assets/imgs/judge01.png'), status: 1 },
        { type: 4, name: '填空题', img: require('@/assets/imgs/fill01.png'), status: 1 },
        //					{type:5,name:'选词填空题',img:require('@/assets/imgs/gapfill01.png'),status:1},
        //					{type:6,name:'连线题',img:require('@/assets/imgs/line01.png'),status:1},
        { type: 7, name: '名词解释题', img: require('@/assets/imgs/explain01.png'), status: 1 },
        { type: 8, name: '简答题', img: require('@/assets/imgs/answer01.png'), status: 1 },
        { type: 9, name: '实训题', img: require('@/assets/imgs/train04.png'), status: 1 },
        { type: 10, name: '排序题', img: require('@/assets/imgs/sort01.png'), status: 1 },
      ],
      optionMap: {
        0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H'
      },
      setInterName: '',//定时器名称
    }
  },
  methods: {
    //初始化数据
    initData: function () {
      this.resetData()
      if (!this.paper_id) {
        return false;
      }
      let params = {
        paper_id: this.paper_id
      }
      selectSinglePaperData(params).then(response => {
        this.showAnswer = response.is_parsing
        if (response.data) {
          this.totalScore = response.data.total_score
          this.totalCount = response.data.count
          var item = response.data.info
          for (var i = 0; i < item.length; i++) {
            var info = {}
            info.type = item[i].paper_type
            info.name = this.findName(item[i].paper_type)
            info.score = item[i].single_score
            info.num = item[i].paper_content_id.length
            info.qArr = item[i].paper_content_id
            this.questions.push(info)
          }
        }
      })
    },
    //创建题型,type:题型类型,name:题型名称
    create: function (type, name) {
      this.lastType = this.activeType //赋值上一个选中的题型
      this.tableVisible = true
      this.activeType = type
      this.editorData = ''
      this.contentId = ''
    },
    //选择问题
    checkQuestion: function (type, index) {
      let it = this.questions.findIndex((val) => {
        return val.type === type
      })
      this.subtitle = this.questions[it].name
      this.activeName = index + 1
      if (this.activeType == type) {
        return true
      } else {
        this.activeType = type
        //					this.lastType = type
        this.questionListVisible = true
        //					this.checkList=[]
        let params = {
          paper_id: this.paper_id,
          paper_type: type
        }
        selectPaperTypeTopic(params).then(response => {
          this.checkList = response.data
          sessionStorage.setItem('checkList', JSON.stringify(this.checkList))
        })
      }

    },
    //主体部分头部选择切换题型,type:题型类型,name:题型名字
    checkType: function (type, name) {
      if (this.activeType == type) {
        return true
      }
      this.activeType = type
      //				this.lastType = type
      this.activeName = ''
      this.subtitle = name
      this.editorData = ''
      this.contentId = ''
      this.questionListVisible = true
      //				this.checkList=[]
      let index = this.questions.findIndex((val) => {
        return val.type === type
      })
      let params = {
        paper_id: this.paper_id,
        paper_type: type
      }
      selectPaperTypeTopic(params).then(response => {
        this.checkList = response.data
        sessionStorage.setItem('checkList', JSON.stringify(this.checkList))
        this.activeName = this.checkList.length
      })

    },
    beforeClose: function () {
      this.tableVisible = false
      this.contentId = ''
      this.editorData = ''
      if (this.lastType) {
        this.activeType = this.lastType
        this.lastType = ''
      }
    },
    //添加题目
    addQuestion: function () {
      this.tableVisible = true
      this.contentId = ''
      this.editorData = ''
    },
    //删除题目,id为题目id,type为题目类型，index为该题目下标值
    delQuestion: function (id, type, index) {
      this.$confirm('确定删除该题目?', '删除题目', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        if (index == this.activeName - 1) {
          if (index >= this.checkList.length - 1) {
            this.activeName = this.checkList.length - 1
          } else {
            this.activeName++
          }
        } else if (index < this.activeName - 1) {
          this.activeName = this.activeName - 1
        }
        this.checkList.splice(index, 1);//删除指定位置数值
        let idx = this.questions.findIndex((val) => {
          return val.type === type
        })
        this.questions[idx].qArr.splice(index, 1)
        this.questions[idx].num--
        this.totalCount--
        if (this.checkList.length == 0) {
          if (idx !== -1) {
            this.questions.splice(idx, 1)
            this.activeType = 0
            this.activeName = 0
            this.subtitle = ''
            this.questionListVisible = false
            this.watchType(type)
          }
        }
        let params = {
          paper_id: this.paper_id,
          paper_content_id: id,
          paper_type: type
        }
        deletePaperTopicContentData(params).then(response => {
          if (response.data) {
            this.totalScore = response.data.total_score
            this.totalCount = response.data.count
            if (response.data.info[type]) {
              this.questions[idx].score = response.data.info[type].single_score
            }
          }
          this.$message.success('删除成功');
        })

      })
        .catch(_ => { })
    },
    //编辑题目,id为题目id,type为题目类型，index为该题目下标值
    editQuestion: function (id, type, index) {
      let lists = JSON.parse(sessionStorage.getItem('checkList'))
      this.editorData = lists[index]
      this.contentId = id
      this.tableVisible = true
    },
    //监控可添加题型
    watchType: function (type = '') {
      if (type) {
        var index = this.typeList.findIndex((val) => {
          return val.type == type
        })
        if (index !== -1) {
          this.typeList[index].status = 1
        }

      } else {
        this.questions.forEach((item) => {
          var index = this.typeList.findIndex((val) => {
            return val.type == item.type
          })
          if (index !== -1) {
            this.typeList[index].status = 0
          }
        })
      }
      let addible = this.typeList.findIndex((val) => {
        return val.status == 1
      })
      if (addible === -1) {
        this.showAddible = false
      } else {
        this.showAddible = true
      }
    },
    resetData: function () {
      this.questions = []
      this.typeList = [
        { type: 1, name: '单选题', img: require('@/assets/imgs/radio01.png'), status: 1 },
        { type: 2, name: '多选题', img: require('@/assets/imgs/multiple01.png'), status: 1 },
        { type: 3, name: '判断题', img: require('@/assets/imgs/judge01.png'), status: 1 },
        { type: 4, name: '填空题', img: require('@/assets/imgs/fill01.png'), status: 1 },
        //					{type:5,name:'选词填空题',img:require('@/assets/imgs/gapfill01.png'),status:1},
        //					{type:6,name:'连线题',img:require('@/assets/imgs/line01.png'),status:1},
        { type: 7, name: '名词解释题', img: require('@/assets/imgs/explain01.png'), status: 1 },
        { type: 8, name: '简答题', img: require('@/assets/imgs/answer01.png'), status: 1 },
        { type: 9, name: '实训题', img: require('@/assets/imgs/train04.png'), status: 1 },
        { type: 10, name: '排序题', img: require('@/assets/imgs/sort01.png'), status: 1 },
      ]
      this.checkList = []
      this.showAnswer = 1//是否显示答案及解析
      this.activeType = 0//主体部分头部题型切换
      this.activeName = 1//题目列表激活的面板
      this.addibleType = []//可添加题型
      this.subtitle = ''//选中题型名称
      this.showAddible = true //显示添加题型按钮
      this.questionListVisible = false
      this.totalScore = ''
      this.totalCount = ''
    },
    examSet() {
      let obj = {
        paper_id: this.paper_id,
        dialogExamVisible: true
      }
      this.$root.$emit('returndialog', obj);
    },
    findName: function (type) {
      if (type == 1) {
        return '单选题'
      } else if (type == 2) {
        return '多选题'
      } else if (type == 3) {
        return '判断题'
      } else if (type == 4) {
        return '填空题'
      } else if (type == 5) {
        return '选词填空题'
      } else if (type == 6) {
        return '连线题'
      } else if (type == 7) {
        return '名词解释题'
      } else if (type == 8) {
        return '简答题'
      } else if (type == 9) {
        return '实训题'
      } else if (type == 10) {
        return '排序题'
      }
    },

    //saveSinglePaper保存试卷题型及题目顺序
    savePaper: function () {
      if (this.questions.length == 0) {
        this.$message('未添加任何题型')
        return
      }
      for (let i = 0; i < this.questions.length; i++) {
        const element = this.questions[i];
        if (!element.qArr) {
          this.$message(element.name + '没有添加任何题目');
          return
        }
      }
      let qTypeArr = [] //试题类型排序
      for (let i = 0; i < this.questions.length; i++) {
        let str = {}
        str.paper_type = this.questions[i]['type']
        str.sort = i + 1
        qTypeArr.push(str)
      }
      let questionArr = []
      for (let i = 0; i < this.questions.length; i++) {
        const item = this.questions[i].qArr
        if (item) {
          for (let j = 0; j < item.length; j++) {
            let str = {}
            str.paper_type = this.questions[i]['type']
            str.paper_content_id = item[j]
            str.topic_sort = j + 1
            questionArr.push(str)
          }
        }
      }
      let params = {
        paper_id: this.paper_id,
        paper_sort: qTypeArr,
        paper_content_sort: questionArr
      }
      saveSinglePaperData(params).then(response => {
        this.$message.success('保存成功')
      })
    },
    //题目顺序拖拽后同步修改questions中的qArr顺序，以便保存试卷信息
    datadragEnd: function (evt) {
      let acName = this.activeName
      this.activeName = 0
      setTimeout(() => {
        this.activeName = acName
      }, 10)
      let index = evt.oldIndex
      let futureIndex = evt.newIndex
      let typeIndex = this.questions.findIndex((val) => {
        return val.type === this.activeType
      })
      let arr = []
      for (let i = 0; i < this.checkList.length; i++) {
        arr.push(this.checkList[i].id)
      }
      this.questions[typeIndex].qArr = arr

    },
    //修改是否显示答案属性
    resetShowAnswer: function () {

    }
  }
}
</script>

<style scoped>
</style>